"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaseTermDateBased = void 0;
exports.isLeaseTermCurrent = isLeaseTermCurrent;
var LeaseTermDateBased = /** @class */ (function () {
    function LeaseTermDateBased() {
        this.id = '';
        this.leaseStartWindowId = '';
        this.startDate = '';
        this.endDate = '';
        this.name = '';
        this.isImmediateMoveIn = false;
        this.maxMoveInDate = '';
        this.isDefault = false;
    }
    return LeaseTermDateBased;
}());
exports.LeaseTermDateBased = LeaseTermDateBased;
/** Date-only lease end dates remain eligible through that UTC calendar day on every client. */
function isLeaseTermCurrent(term, now) {
    if (now === void 0) { now = new Date(); }
    if (!term.endDate)
        return true;
    if (/^\d{4}-\d{2}-\d{2}$/.test(term.endDate)) {
        var utcToday = now.toISOString().slice(0, 10);
        return term.endDate >= utcToday;
    }
    var endDate = new Date(term.endDate);
    return !Number.isNaN(endDate.getTime()) && endDate >= now;
}
